import ajax from './ajax';

export function getPackageInfo() {
  return ajax('/resources/get-package-info/');
}

export function getSubscriptionInfo() {
  return ajax('/resources/get-subscription/',  {method: 'POST' });
}

export function getSubscriptionStatus() {
  return ajax('/resources/stripe-subscription-status/',  {method: 'POST' });
}
